import styled from 'styled-components';
import { p } from 'styled-components-spacing';
import theme from '@lib/theme';
import breakpoint from 'styled-components-breakpoint';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';

export const StyledDetailsCover = styled.div`
  margin-top: 2rem;
  border-radius: 8px;
  ${({ homePage }) => !homePage
&& `
   border: 2px solid ${theme.colors.gray};
`}

  ${breakpoint('mobile', 'tablet')`
    margin-top: 1rem;
  `}
`;
export const StyledSepratorGray = styled.hr`
  color: ${theme.colors.gray};
  margin: 0;
  width: calc(100% - 2px);
  ${({ islast }) => islast && 'display: none;'}
`;
export const StyledMainHeadline = styled.div`
  color: ${props => (props.treatment ? '#6B6565' : '#2485a6')};
  font-size: 26px;
  font-weight: bold;
  ${p(3)};
  ${breakpoint('mobile', 'tablet')`
    font-size: 18px;
    line-height: 24px;
    padding: 20px 10px;
  `}
`;
export const StyledTitle = styled.div`
  color: ${props => (props.treatment ? '#6B6565' : '#3a3a3a')};
  font-size: 22px;
  padding: 10px 0;
  font-weight: 700;
  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
    line-height: 24px;
  `}
`;
export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  ${p(3)};
  border-radius: 8px;
  ${breakpoint('mobile', 'tablet')`
    padding: 10px;
  `}
`;
export const StyledIconWrapper = styled.div`
  display: flex;
  svg,
  path {
    width: 20px;
    height: 20px;
    fill: ${props => (props.active ? theme.colors.logoBlue : '#3a3a3a')};
    transform-origin: center;
    transform: ${props => (props.active ? 'rotate(90deg)' : '')};
    transition: all 500ms ease-in-out 0s;
  }
`;
export const StyledDescription = styled.div`
  ${RichTextStyle}
  position: relative;
  border-radius: 8px;
  line-height: 39px;
  display: ${props => (props.active ? 'block' : 'none')};
  ${p(3)};
  transition: all 500ms ease-in-out 0s;
  ${breakpoint('mobile', 'tablet')`
    font-size: 13vw;
    line-height: 24px;
  `}
`;
